import { ConvenienceChainProxy } from 'models/google_place_chain'
import {
  buildGooglePlaceSummaryContent,
  buildGooglePlaceLocationContent,
  GOOGLE_PLACE_CONFIGS,
} from '../utils/googlePlacesHelpers'
import { BuildCompanyTypeContentOptions, CompanyTypePageContent } from './types'

/**
 * Shared convenience-store content derivation used by both `NewConveniencePage`
 * (desktop) and `MobileConveniencePage`. Reuses the Google-Places content
 * helpers. See {@link CompanyTypePageContent}.
 */
export function buildConveniencePageContent(
  data: ConvenienceChainProxy | undefined,
  { onViewDoors }: BuildCompanyTypeContentOptions = {}
): CompanyTypePageContent {
  const cstore = data?.cstore
  const config = GOOGLE_PLACE_CONFIGS.convenience

  const summaryContent = buildGooglePlaceSummaryContent({
    placeData: cstore,
    onViewDoorsClick: onViewDoors ?? (() => {}),
    hideDoorsMetric: !onViewDoors,
  })

  const locationDetailsContent = buildGooglePlaceLocationContent(cstore)

  return {
    documentTitle: `${cstore?.name || 'Not Found'} (Convenience Store) - First Bite`,
    header: {
      name: cstore?.name ?? '',
      domain: cstore?.domain ?? undefined,
      logoUrl: undefined,
    },
    contactCompanyId: data?.id,
    doorsCount: cstore?.doors_cnt ?? 0,
    summaryContent,
    locationDetailsContent,
    breadcrumbRoot: config.breadcrumbRoot,
    breadcrumbTitle: config.breadcrumbTitle,
    categoryInfo: {
      categorySlug: 'retail',
      subCategorySlug: 'convenience',
    },
    companyTypeSlug: 'convenience',
    tableTypeSlug: 'convenience',
    modalSubCategory: {
      name: config.modalName,
      // config.modalSlug is typed loosely as string; this literal is the same value.
      slug: 'convenience',
      description: config.modalName,
    },
  }
}
